import { ContextConsumer } from "@lit/context";
import type { LitElement } from "lit";
import { tvrnServiceCtx } from "#app/context.ts";

type Constructor<T = unknown> = new (
  // biome-ignore lint/suspicious/noExplicitAny: using `unknown` triggers TS2545, see <https://github.com/microsoft/TypeScript/issues/37142>
  ...args: any[]
) => T;

const redirectToSignIn = () => {
  const target = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  window.location.replace(
    "/sign-in.html".concat(
      ...(target.length > 1 ? ["?redirect=", encodeURIComponent(target)] : []),
    ),
  );
};

export const SignedInOnly = <T extends Constructor<LitElement>>(el: T) =>
  class extends el {
    #tvrnService = new ContextConsumer(this, {
      context: tvrnServiceCtx,
      callback: (api) => {
        api.addEventListener(
          "tvrn.deauthorized",
          () => void redirectToSignIn(),
        );

        if (!api.authorized) {
          redirectToSignIn();
        }

        this.requestUpdate();
      },
    });

    override shouldUpdate(): boolean {
      return this.#tvrnService.value?.authorized === true;
    }
  } as T;
